import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getAthleteDetails = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_DETAILS,
    params: {
      ath_id: data.ath_id,
    },
  });

  return response.data;
};

export const getAthleteStats = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_STATS,
    params: {
      ath_id: data.ath_id,
    },
  });

  return response.data;
};

export const getAthleteHighlights = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_HIGHLIGHTS,
    params: {
      page: data?.page || 1,
      limit: data?.limit || 24,
      geo_lat: data?.geo_lat || 0,
      geo_long: data?.geo_long || 0,
      ath_id: data.ath_id,
    },
  });

  return response.data;
};

export const getAthletePosts = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.ATHLETE_POSTS,
    params: {
      page: data?.page || 1,
      limit: data?.limit || 24,
      geo_lat: data?.geo_lat || 0,
      geo_long: data?.geo_long || 0,
      ath_id: data.ath_id,
    },
  });

  return response.data;
};
